import {
  Project,
  ReducedAllotmentNode,
  Histogram,
} from '@photocarbone/nooco-shared-api-def';
import {
  getFormattedWeightNumber,
  getUnitConversion,
} from '../../../services/mathematics/formatNumber';
import { Unit } from '../utils';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { StateDTO } from '../../../models/GeneralDTO';
import { getSubZonesRecursive } from '../../../../functions/parseProject';
import { FullScreenModal, HistogramVignetteComponent } from '@photocarbone/nooco-ui';
import { useTranslation } from 'react-i18next';

let dataParsingHistogram = new Histogram();

function getDatasForHistogram(
  currentProject: Project,
  allotmentNodes: Map<number, ReducedAllotmentNode>
) {
  let projectSheets = getSubZonesRecursive(currentProject);
  const { graphData, graphKeys, impactTotal } =
    dataParsingHistogram.processDataGraph(
      1,
      allotmentNodes,
      projectSheets,
      currentProject
    );

  return { graphData, graphKeys, impactTotal };
}

function Summary({
  icProjet,
  area,
  refUnit,
  projectData,
}: {
  icProjet: number;
  area: number;
  refUnit: Unit;
  projectData: Project;
}) {
  const { t } = useTranslation();
  const { globalDataInstance } = useSelector((state: StateDTO) => state.projects);
  const allDatasForGraph = useMemo(
    () => getDatasForHistogram(projectData, globalDataInstance.allotmentNodes),
    [projectData]
  );
  const [isOpen, setIsOpen] = React.useState(false);

  const formattedIcProjet =
    refUnit === 'm²'
      ? `${getFormattedWeightNumber(icProjet)} ${getUnitConversion(icProjet)}/m²`
      : `${getFormattedWeightNumber(icProjet * area)} ${getUnitConversion(
          icProjet * area
        )}`;

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          columnGap: '4px',
          marginBottom: '16px',
          padding: '9px 16px',
          borderRadius: '6px',
          backgroundColor: 'white',
        }}
      >
        <span style={{ fontSize: '14px', color: '#2B36748F', fontWeight: '700' }}>
          {t('APP.PROJECT.SIMULATOR.SUMMARY.IMPACT.RESULT', {
            defaultValue: 'Calcul dynamique Nooco',
          })}{' '}:
        </span>
        <span
          style={{
            fontSize: '14px',
            fontWeight: '700',
            color: '#2B3674',
          }}
        >
          {formattedIcProjet}
        </span>
      </div>
      {allDatasForGraph && (
        <div style={{ width: '100%', height: '45vh' }}>
          <HistogramVignetteComponent
            data={allDatasForGraph.graphData}
            keys={allDatasForGraph.graphKeys}
            total={allDatasForGraph.impactTotal}
            isBackgroundVisible={true}
            onClickFullscreen={() => setIsOpen(true)}
            currentProject={projectData}
          />

          <FullScreenModal
            needBasicFooter={false}
            setOpenModal={() => setIsOpen(false)}
            openModal={isOpen}
            bodyContent={
              <HistogramVignetteComponent
                data={allDatasForGraph.graphData}
                keys={allDatasForGraph.graphKeys}
                total={allDatasForGraph.impactTotal}
                isBackgroundVisible={true}
                currentProject={projectData}
                isZoom
              />
            }
          />
        </div>
      )}
    </div>
  );
}

export default Summary;
